import { isPos, posRoot } from 'src/config'
import Model from 'src/models/model'
import RegisterClient from 'src/models/register/RegisterClient'
import { checkPreviewPermissionsAccess } from 'src/router/guards'

export default ({ router, app }) => {
  if (!isPos) return

  /**
   * Set global guards
   */
  router.beforeEach(checkPreviewPermissionsAccess)

  async function quitRegister () {
    if (Model.context.currentRegisterClient) {
      await Model.context.currentRegisterClient.delete()
    }
    if (Model.context.currentUser) {
      await Model.context.currentUser.logOut()
    }
    await Model.configuration.validate()
    await Model.context.fetch(true)
    router.replace({ name: 'auth:login' })
  }
  app.config.globalProperties.$quitRegister = quitRegister
  app.$quitRegister = quitRegister

  /**
   * Set routes
   */
  const routeData = {
    name: 'pos:root',
    path: posRoot,
    component: () => import('src/modules/register/layouts/RegisterLayout'),
    beforeEnter: async (_to, _from, next) => {
      await Model.configuration.ensureLoaded()

      if (!Model.context.currentRegisterClient) {
        // If the user is logged in we need to create the current register client
        Model.context.currentRegisterClient = new RegisterClient({}, { registerStation: true })
      }

      // If there is no register client and not logged in, force login
      // If there are either of those, handle from the register layout screen
      if (Model.context.currentRegisterClient.isLocal && !Model.context.currentUser) {
        next({ name: 'auth:login' })
        return
      }

      next()
    }
  }

  router.addRoute(routeData)

  if (isPos) {
    router.addRoute({ name: 'app:root', redirect: { name: 'pos:root' } })
  }
}
